
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/custom-fields?${queryString}`);
    return response.data;
  },
  async add(payload) {
    const response = await https.post(`/custom-fields`, payload);
    return response.data;
  },

  async update(id, payload) {
    console.log(payload,'payload')
    const response = await https.put(`/custom-fields/${id}`, payload);
    return response.data;
  },

  async deleteById(id) {
    const response = await https.delete(`/custom-fields/${id}`);
    return response.data;
  },
});

